import { render, staticRenderFns } from "./ui-breadcrumbs.vue?vue&type=template&id=19230657"
import script from "./ui-breadcrumbs.vue?vue&type=script&lang=ts"
export * from "./ui-breadcrumbs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports